import type { Theme } from "@material-ui/core";
import { Machine } from "xstate";

interface NavMachineSchema {
  states: {
    pinned: Record<string, unknown>;
    rail: Record<string, unknown>;
    open: Record<string, unknown>;
    closed: Record<string, unknown>;
  };
}

type NavEvents =
  | { type: "HOVER" }
  | { type: "UNHOVER" }
  | { type: "CLOSE" }
  | { type: "PIN" }
  | { type: "UNPIN" }
  | { type: "RESET" }
  | { type: "SELECT" };

interface NavContext {
  theme: Theme;
}

const navMachine = Machine<NavContext, NavMachineSchema, NavEvents>({
  id: "navMenu",
  initial: "rail",
  states: {
    pinned: {
      on: {
        UNPIN: "rail",
      },
    },
    rail: {
      on: {
        HOVER: "open",
        CLOSE: "closed",
      },
    },
    open: {
      on: {
        PIN: "pinned",
        UNHOVER: "rail",
        CLOSE: "closed",
      },
    },
    closed: {
      on: {
        SELECT: "open",
        RESET: "rail",
      },
    },
  },
});

export default navMachine;
